module.exports = __webpack_public_path__ + "img/9788971969083.4d0e6111.jpg";